/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/AddAction/Add/Content/Procedures/Error"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Something went wrong. Please try again later."
/>
{children}
</React.Fragment>)
}